import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_BUILDING_OFFICE: GlameraIconDefinition = {
  name: 'building-office',
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
  svg: `
    <path class="glm-building-office-body" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"></path>
    <path class="glm-building-office-window glm-building-office-floor-0" d="M9 12.75h1.5"></path>
    <path class="glm-building-office-window glm-building-office-floor-0" d="M13.5 12.75H15"></path>
    <path class="glm-building-office-window glm-building-office-floor-1" d="M9 9.75h1.5"></path>
    <path class="glm-building-office-window glm-building-office-floor-1" d="M13.5 9.75H15"></path>
    <path class="glm-building-office-window glm-building-office-floor-2" d="M9 6.75h1.5"></path>
    <path class="glm-building-office-window glm-building-office-floor-2" d="M13.5 6.75H15"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-building-office-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './building-office.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BuildingOfficeIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_BUILDING_OFFICE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
